import React, { useRef, useState } from 'react';
import { accountHeaders } from '../utils/accountFetch';
const { getApiUrl } = require('../config/serverEndpoint');
const { appleIdentityPlugin, appleCredential } = require('../utils/nativeAppleIdentity');
export default function AppleIdentityButton({ purpose = 'login', username, onCredential, label }) {
  const lock = useRef(false), [busy, setBusy] = useState(false), [error, setError] = useState('');
  if (!appleIdentityPlugin()) return null;
  async function signIn() {
    if (lock.current) return;
    lock.current = true; setBusy(true); setError('');
    try {
      const credential = await appleCredential({ purpose, username, headers: purpose === 'login' ? {} : accountHeaders(), apiUrl: getApiUrl });
      // Reject an account switch while Apple's sheet was open.
      if (purpose !== 'login' && window.sessionStorage.getItem('username') !== username) throw Error('Oturum değişti. Tekrar dene.');
      await onCredential(credential);
    } catch (cause) { if (cause.message !== 'cancelled') setError(cause.message || 'Apple girişi tamamlanmadı.'); }
    finally { lock.current = false; setBusy(false); }
  }
  return <div className="w-full max-w-[300px]"><button type="button" disabled={busy} onClick={signIn} className="min-h-12 w-full rounded-xl bg-black px-4 py-3 font-semibold text-white disabled:opacity-50"><span aria-hidden="true"> </span>{busy ? 'Bağlanıyor…' : (label || 'Apple ile devam et')}</button>{error && <p role="alert" className="mt-2 text-xs text-red-700">{error}</p>}</div>;
}
